import { render } from "./Clientapis.vue?vue&type=template&id=a3b051c0"
import script from "./Clientapis.vue?vue&type=script&lang=js"
export * from "./Clientapis.vue?vue&type=script&lang=js"

import "./Clientapis.vue?vue&type=style&index=0&id=a3b051c0&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__